var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.125 0C0.503906 0 0 0.503906 0 1.125V8.625C0 9.24609 0.503906 9.75 1.125 9.75H1.5C1.5 10.9922 2.50781 12 3.75 12C4.99219 12 6 10.9922 6 9.75H9C9 10.9922 10.0078 12 11.25 12C12.4922 12 13.5 10.9922 13.5 9.75H14.25C14.6648 9.75 15 9.41484 15 9C15 8.58516 14.6648 8.25 14.25 8.25V6.75V6V5.56172C14.25 5.16328 14.093 4.78125 13.8117 4.5L12 2.68828C11.7188 2.40703 11.3367 2.25 10.9383 2.25H9.75V1.125C9.75 0.503906 9.24609 0 8.625 0H1.125ZM9.75 3.75H10.9383L12.75 5.56172V6H9.75V3.75ZM4.875 9.75C4.875 10.3711 4.37109 10.875 3.75 10.875C3.12891 10.875 2.625 10.3711 2.625 9.75C2.625 9.12891 3.12891 8.625 3.75 8.625C4.37109 8.625 4.875 9.12891 4.875 9.75ZM11.25 10.875C10.6289 10.875 10.125 10.3711 10.125 9.75C10.125 9.12891 10.6289 8.625 11.25 8.625C11.8711 8.625 12.375 9.12891 12.375 9.75C12.375 10.3711 11.8711 10.875 11.25 10.875Z",
    fill: "black"
  })));
};

export default __webpack_public_path__ + "static/media/shipping-truck.0622d106.svg";
export { SvgComponent as ReactComponent };